/**
 * Universal clipboard helper with a success toast.
 * Falls back to the legacy `document.execCommand('copy')` trick on iOS / older
 * browsers that haven't granted clipboard permission.
 */
import { toast } from "sonner";

export async function copyToClipboard(value, label = "") {
  const text = (value ?? "").toString();
  if (!text) {
    toast.error("Nothing to copy.");
    return false;
  }
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
    } else {
      // Legacy fallback for iOS / non-secure contexts.
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    toast.success(label ? `${label} copied` : "Copied to clipboard", {
      description: text.length > 48 ? `${text.slice(0, 48)}…` : text,
      duration: 2200,
    });
    return true;
  } catch (err) {
    toast.error("Couldn't copy — please copy manually.");
    return false;
  }
}
